package pwgs.ui.scenes.userreportsscene


class UserReportsControllerFe(props: UserReportsSceneProps, scene: MUserReportsScene) : AUserReportsControllerFe(props, scene) {

    override fun createInitialModel() : UserReportsSceneModel {
        return UserReportsSceneModel(listOf())
    }

    override fun init() {
        call_load()
    }


}

